import { render } from "./Theater.vue?vue&type=template&id=5b75d80c&scoped=true"
import script from "./Theater.vue?vue&type=script&lang=js"
export * from "./Theater.vue?vue&type=script&lang=js"

import "./Theater.vue?vue&type=style&index=0&id=5b75d80c&scoped=true&lang=css"

import exportComponent from "E:\\sanket\\rio\\rio_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b75d80c"]])

export default __exports__